import type { GasCurveChartContext, GasCurveChartData } from "./d";
import type { ScenarioCalculations } from "@/composables/scenarioCalculations/calculationTypes";
import { getFreeGasDataSet } from "./getFreeGasDataSet";
import { getMaxGasAllowedDataSet } from "./getMaxGasAllowedDataSet";
import { getPumpThresholds } from "./getPumpThresholds";

const buildGasCurveChartContext = (
  calcs: ScenarioCalculations
): GasCurveChartContext => {
  const context: GasCurveChartContext = {
    ascendingOrderPumps: calcs.ascendingOrderPumps.value,
    individualPumpCalculations: calcs.pumpCalculations.individual.value
  };

  return context;
};

export const useGasCurveChartData = (
  scenarioCalculations: ScenarioCalculations
): GasCurveChartData | undefined => {
  const context = buildGasCurveChartContext(scenarioCalculations);

  const freeGasDataSet = getFreeGasDataSet(context);
  const pumpThresholds = getPumpThresholds(context);
  const maxGasAllowedDataSet = getMaxGasAllowedDataSet(context, pumpThresholds);

  if (!context) {
    return undefined;
  } else {
    return {
      context,
      freeGasDataSet,
      maxGasAllowedDataSet,
      pumpThresholds
    };
  }
};
